import { Component, OnInit } from '@angular/core';
import { CartService } from '../../service/cart.service';
import { ProgressLoaderService } from '../../service/progress-loader.service';
import { CartResponse, OrderDetail } from '../../models/cart-item';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { BadgeModule } from 'primeng/badge';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { OrdersService } from '../../service/orders.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../service/language.service';
import { ScreenSizeService } from '../../service/screen-size.service';
import { MessageService } from 'primeng/api';
import { CustomToastrService } from '../../service/custom-toastr.service';

@Component({
    selector: 'app-order-detail',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        CardModule,
        FileUploadModule,
        CalendarModule,
        InputTextModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        ButtonModule,
        TooltipModule,
        MessagesModule,
        DividerModule,
        ToastModule,
        BadgeModule,
        InputNumberModule,
        TableModule,
        TranslateModule,
        PanelModule,
    ],
    templateUrl: './order-detail.component.html',
    styleUrl: './order-detail.component.scss',
})
export class OrderDetailComponent implements OnInit {
    order!: OrderDetail;
    selectedLanguage: any = null;

    constructor(
        private orderService: OrdersService,
        private router: Router,
        private translate: TranslateService,
        private messageService: MessageService,
        private toast: CustomToastrService,
        private languageService: LanguageService,
        private route: ActivatedRoute,
        private progressLoader: ProgressLoaderService,
        private screenSizeService: ScreenSizeService
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            const orderId: string = params.get('id')!;
            this.fetchOrder(orderId);
        });
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    getDeviceType(): string {
        return this.screenSizeService.getDeviceType();
    }

    checkout(): void {
        const isOrder = true;
        this.router.navigate(['/home/cart/pay/'.concat(this.order.id)]);
    }

    isPayable(): boolean {
        return this.order.status === 'OPEN';
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    fetchOrder(orderId: string): void {
        this.progressLoader.show('Fetching order');
        this.orderService.getOrder(orderId).subscribe({
            next: (value) => {
                this.order = value;
                this.progressLoader.hide();
            },
            error: (err) => {
                this.progressLoader.hide();
                this.toast.showError(this.translate.instant(err.error.messageKey))
            },
        });
    }
}
